import QuillBlock from 'quill/blots/block';
import type { Blot, LeafBlot } from '../types';

const getClosestLine = (blot: LeafBlot | null) => {
  let current: Blot | null = blot;
  while (current && !(current instanceof QuillBlock)) {
    current = current.parent;
  }
  return current;
};

export default getClosestLine;
